import script from "./ApiKeyGate.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiKeyGate.vue?vue&type=script&setup=true&lang=js"

import "./ApiKeyGate.vue?vue&type=style&index=0&id=d8c086e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8c086e4"]])

export default __exports__